
import React from 'react';
import Gauge from 'react-svg-gauge';

const temp_gauge = (props) => {
	
	let temperature = props.temp;
	let gauge_color = '#ADD8E6'; // light blue

	if (temperature >= 50.0 && temperature  < 82.0) {
		gauge_color = '#8DCB41'; // green
	}
	if (temperature >= 82.0 && temperature < 92.0) {
		gauge_color = '#EED202'; // safety yellow
	}
	if (temperature >= 92.0) {
		gauge_color = '#CE2029'; // fire engine red
	}

	// Set current display
	return (
		<div>
        	<Gauge 
        		value={temperature} 
        		width={300} 
				height={240} 
        		color={gauge_color}
        		minMaxLabelOffset={0}
        		topLabelStyle={{fill: 'grey',fontSize: 18}}
        		valueLabelStyle={{fontSize: 36}}
        		label="Temperature (&#xb0;F)"
        	/>
        </div>
	);
}

export default temp_gauge;